/**
 *
 * @param outcome
 * @returns {{"--outcome-primary": (string|*), "--outcome-tertiary": (string|*), "--outcome-secondary": (string|*), "--outcome-primary-faded": string}|{"--outcome-primary": string, "--outcome-tertiary": string, "--outcome-secondary": string, "--outcome-primary-faded": string}}
 */
export function getCSSVars(selectedOutcome) {
  let primaryColorFaded = selectedOutcome
    ? selectedOutcome.primaryColor
      ? selectedOutcome.primaryColor.split("#")
      : ["", "162c47"]
    : "#162c47";
  let primaryColorFadedString = "#" + primaryColorFaded[1] + "80";
  if (selectedOutcome) {
    return {
      "--outcome-primary": selectedOutcome.primaryColor
        ? selectedOutcome.primaryColor
        : "#162c47",
      "--outcome-secondary": selectedOutcome.secondaryColor
        ? selectedOutcome.secondaryColor
        : "#162c47",
      "--outcome-tertiary": selectedOutcome.tertiaryColor
        ? selectedOutcome.tertiaryColor
        : "#162c47",
      "--outcome-primary-faded": primaryColorFadedString
    };
  } else {
    return {
      "--outcome-primary": "#162c47",
      "--outcome-secondary": "white",
      "--outcome-tertiary": "#162c47",
      "--outcome-primary-faded": "#162c47"
    };
  }
}
